import {
  IPackageOverrideWithQuantity,
  IPricedServiceCodeEntry,
  ITreatmentPackage,
  ITreatmentPackagePriceOverride,
} from '@principle-theorem/principle-core/interfaces';
import { v4 as uuid } from 'uuid';

export class TreatmentPackage {
  static init(overrides: Partial<ITreatmentPackage> = {}): ITreatmentPackage {
    return {
      uid: uuid(),
      name: 'New Package',
      description: '',
      isDefault: false,
      priceOverrides: [],
      ...overrides,
    };
  }

  static getMappedPriceOverrides(
    serviceCodes: IPricedServiceCodeEntry[],
    priceOverrides: ITreatmentPackagePriceOverride[]
  ): IPackageOverrideWithQuantity[] {
    return serviceCodes.map((serviceCode, index) =>
      TreatmentPackage.getMappedPriceOverride(
        serviceCode,
        index,
        serviceCodes,
        priceOverrides
      )
    );
  }

  static getMappedPriceOverride(
    serviceCode: IPricedServiceCodeEntry,
    index: number,
    serviceCodes: IPricedServiceCodeEntry[],
    priceOverrides: ITreatmentPackagePriceOverride[]
  ): IPackageOverrideWithQuantity {
    const matchingServiceCodesBeforeIndex = serviceCodes
      .slice(0, index)
      .filter(
        (code) =>
          code.code === serviceCode.code && code.type === serviceCode.type
      );

    const matchingOverrides = priceOverrides.filter(
      (price) =>
        price.code === serviceCode.code && price.type === serviceCode.type
    );

    const matchingOverride =
      matchingOverrides[matchingServiceCodesBeforeIndex.length];

    return {
      code: serviceCode.code,
      type: serviceCode.type,
      price: matchingOverride?.price ?? undefined,
      quantity: serviceCode.quantity,
    };
  }
}
